import { numberToPrettyString } from '@cian/utils';
import { getFormattedDate } from './getFormattedDate';
var Currencies = {
  eur: '€',
  rur: '₽',
  usd: '$'
};
var CurrencyPostfix = {
  rent: '/мес.',
  rentDaily: '/сут.',
  sale: ''
};

/* istanbul ignore next */
export function buildPriceHistory(events) {
  return events.map(function (event, index, array) {
    if (index === 0) {
      return getStartPriceString(event);
    }

    var prevEvent = array[index - 1];

    if (prevEvent.priceData.currency !== event.priceData.currency) {
      return getOtherCurrencyString(event);
    }

    return getPriceDiffString(array[index - 1], event);
  });
}
export function getCurrencySign(currency) {
  var dealType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sale';
  return currency ? Currencies[currency] + CurrencyPostfix[dealType] : '';
}
/* istanbul ignore next */

export function getStartPriceString(startPriceEvent) {
  var _startPriceEvent$pric = startPriceEvent.priceData,
      price = _startPriceEvent$pric.price,
      currency = _startPriceEvent$pric.currency,
      paymentPeriod = _startPriceEvent$pric.paymentPeriod,
      changeTime = startPriceEvent.changeTime;
  return {
    currency: currency,
    date: getFormattedDate(new Date(changeTime)),
    diff: '',
    newPrice: numberToPrettyString(price),
    paymentPeriod: paymentPeriod,
    trend: 'none'
  };
}
/* istanbul ignore next */

export function getOtherCurrencyString(priceEvent) {
  var _priceEvent$priceData = priceEvent.priceData,
      price = _priceEvent$priceData.price,
      currency = _priceEvent$priceData.currency,
      paymentPeriod = _priceEvent$priceData.paymentPeriod,
      changeTime = priceEvent.changeTime;
  return {
    currency: currency,
    date: getFormattedDate(new Date(changeTime)),
    diff: 'Смена валюты',
    newPrice: numberToPrettyString(price),
    paymentPeriod: paymentPeriod,
    trend: 'none'
  };
}
/* istanbul ignore next */

export function getPriceDiffString(oldPriceEvent, newPriceEvent) {
  var oldPrice = oldPriceEvent.priceData.price;
  var newPrice = newPriceEvent.priceData.price;
  var _newPriceEvent$priceD = newPriceEvent.priceData,
      currency = _newPriceEvent$priceD.currency,
      paymentPeriod = _newPriceEvent$priceD.paymentPeriod;
  var priceDiff = newPrice - oldPrice;
  return {
    currency: currency,
    date: getFormattedDate(new Date(newPriceEvent.changeTime)),
    diff: "".concat(numberToPrettyString(Math.abs(priceDiff))),
    newPrice: numberToPrettyString(newPrice),
    paymentPeriod: paymentPeriod,
    trend: priceDiff > 0 ? 'increase' : 'decrease'
  };
}